import * as React from "react"

function RemoveParticipantSvgComponent (props) {
    return (
        <svg
            data-name="Group 1983"
            xmlns="http://www.w3.org/2000/svg"
            width={21}
            height={21}
            {...props}
        >
            <circle
                data-name="Ellipse 93"
                cx={10.5}
                cy={10.5}
                r={10.5}
                fill="#f1585e"
            />
            <g data-name="Group 690">
                <path
                    data-name="Line 48"
                    fill="none"
                    stroke="#fff"
                    d="M5.417 10.5h10.245"
                />
            </g>
        </svg>
    )
}

export default RemoveParticipantSvgComponent
